// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Resume section styles. */

/* Section actions */
.resume__edit-button {
  width: auto;
  min-width: 0;
  max-width: none;
  padding: var(--spacing-xxs, 0.3125rem);
  border: none;
  background: none;
  color: var(--color-primary, #7C4DFF);
  cursor: var(--profile-interactive-cursor, pointer);
  font-size: var(--font-size-sm, 0.875rem);
}

solid-ui-button.resume__edit-button {
  width: auto;
  min-width: 0;
  max-width: none;
  --button-height-sm: 0;
  --button-padding-sm: var(--spacing-xxs, 0.3125rem);
  --button-font-size-sm: var(--font-size-sm, 0.875rem);
  --button-font-weight: var(--font-weight-regular, 400);
  --button-background: transparent;
  --button-border-width: 0;
  --button-border: transparent;
  --button-text: var(--color-primary, #7C4DFF);
  --button-hover-background: transparent;
  --button-hover-border: transparent;
  --button-hover-text: var(--color-primary, #7C4DFF);
}

.resume__edit-button:hover {
  text-decoration: underline;
}

solid-ui-button.resume__edit-button:hover::part(button),
solid-ui-button.resume__edit-button:focus-visible::part(button) {
  text-decoration: underline;
}

.resume-card {
  --resume-card-section-gap: var(--spacing-md, 1.25rem);
  --resume-card-item-gap: var(--spacing-xs, 0.75rem);
  --resume-card-header-gap: var(--spacing-sm, 0.75rem);
  --resume-card-column-gap: var(--spacing-md, 1.25rem);
  --resume-card-row-gap: var(--spacing-2xs, 0.625rem);
  --resume-card-title-color: var(--color-text-subheading, var(--gray-900, #101828));
  --resume-card-title-size: var(--font-size-lg, 1.125rem);
  --resume-card-title-weight: var(--font-weight-bold, 600);
  --resume-card-organization-color: var(--color-text-secondary, var(--gray-600, #4A5565));
  --resume-card-organization-size: var(--font-size-md, 1rem);
  --resume-card-organization-weight: var(--font-weight-md, 500);
  --resume-card-location-color: var(--color-text-secondary, var(--gray-600, #4A5565));
  --resume-card-location-size: var(--font-size-sm, 0.875rem);
  --resume-card-location-weight: var(--font-weight-normal, 400);
  --resume-card-period-color: var(--color-text-secondary, var(--gray-600, #4A5565));
  --resume-card-period-size: var(--font-size-sm, 0.875rem);
  --resume-card-period-weight: var(--font-weight-normal, 400);
  --resume-card-description-color: var(--color-text-primary, var(--gray-700, #364153));
  --resume-card-description-size: var(--font-size-sm, 0.875rem);
  --resume-card-description-weight: var(--font-weight-normal, 400);
  --resume-card-heading-color: var(--color-text-subheading, #101828);
  --resume-card-heading-border: var(--color-border-pale, #eee);
}

/* Section layout */
.resume-card__section {
  margin-bottom: var(--resume-card-section-gap);
}

.resume-card__section > ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.resume-card__item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-areas:
    "title period"
    "organization organization"
    "description description";
  column-gap: var(--resume-card-column-gap);
  row-gap: var(--resume-card-row-gap);
  align-items: start;
  margin: 0 0 var(--resume-card-item-gap) 0;
  font-size: var(--font-size-base, 1rem);
  line-height: var(--line-height-base, 1.5);
  gap: 0;
}

.resume-card__item:last-child {
  margin-bottom: 0;
}

.resume-card__item-header {
  grid-area: title;
  display: flex;
  align-items: baseline;
  gap: var(--resume-card-header-gap);
  min-width: 0;
}

.resume-card__item-header h3,
.resume-card__item-header h4,
.resume-card__item-header time {
  margin: 0;
}

.resume-card__item-header h3,
.resume-card__item-header h4 {
  min-width: 0;
  color: var(--resume-card-title-color);
  font-size: var(--resume-card-title-size);
  font-weight: var(--resume-card-title-weight);
  line-height: var(--line-height-tight, 1.4);
}

.resume-card__item-period {
  grid-area: period;
  justify-self: end;
  text-align: right;
  margin: 0;
  color: var(--resume-card-period-color);
  font-size: var(--resume-card-period-size);
  font-weight: var(--resume-card-period-weight);
  line-height: var(--line-height-tight, 1.4);
}

.resume-card__organization {
  grid-area: organization;
  margin: 0;
  line-height: var(--line-height-base, 1.5);
}

.resume-card__organization-name {
  color: var(--resume-card-organization-color);
  font-size: var(--resume-card-organization-size);
  font-weight: var(--resume-card-organization-weight);
}

.resume-card__organization-separator,
.resume-card__organization-location {
  color: var(--resume-card-location-color);
  font-size: var(--resume-card-location-size);
  font-weight: var(--resume-card-location-weight);
}

/* Description toggle */
.resume-card__description-wrap {
  grid-area: description;
  --resume-card-description-offset: var(--spacing-sm, 0.938rem);
  --resume-description-toggle-inline-offset: 0;
  --resume-description-toggle-line-top: calc(100% - 1.5em + 0.28em - 11px);
  --resume-description-toggle-line-translate-y: 7px;
  --resume-description-overflow-padding-inline-end: 4.5rem;
  margin: var(--resume-card-description-offset) 0 0;
  position: relative;
  isolation: isolate;
}

.resume-card__description-text {
  margin: 0;
  width: 100%;
  max-width: none;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  color: var(--resume-card-description-color);
  font-size: var(--resume-card-description-size);
  font-weight: var(--resume-card-description-weight);
  line-height: var(--line-height-base, 1.5);
  overflow: hidden;
}

.resume-card__description-text--overflowing {
  padding-right: var(--resume-description-overflow-padding-inline-end);
}

.resume-card__description-text--expanded {
  display: block;
  -webkit-line-clamp: unset;
  line-clamp: unset;
  padding-right: 0;
  overflow: visible;
}

.resume-card__description-toggle,
solid-ui-button.resume-card__description-toggle {
  margin: 0;
  padding: 0;
  position: absolute;
  right: var(--resume-description-toggle-inline-offset);
  bottom: 0;
  background-color: var(--color-card-bg, #FFF);
  white-space: nowrap;
  z-index: 0;
}

.resume-card__description-toggle {
  border: 0;
  background: transparent;
  color: var(--color-primary, #7C4DFF);
  cursor: var(--profile-interactive-cursor, pointer);
  font: inherit;
  font-size: var(--font-size-sm, 0.875rem);
  line-height: var(--line-height-base, 1.5);
  min-height: auto;
  min-width: auto;
}

solid-ui-button.resume-card__description-toggle {
  min-height: 0;
  min-width: 0;
  --button-height-sm: 0;
  --button-padding-sm: 0;
  --button-font-size-sm: var(--font-size-sm, 0.875rem);
  --button-line-height: var(--line-height-base, 1.5);
  --button-background: transparent;
  --button-border-width: 0;
  --button-border: transparent;
  --button-text: var(--color-primary, #7C4DFF);
  --button-hover-background: transparent;
  --button-hover-border: transparent;
  --button-hover-text: var(--color-primary, #7C4DFF);
}

.resume-card__description-wrap .resume-card__description-text:not(.resume-card__description-text--expanded) + .resume-card__description-toggle,
.resume-card__description-wrap .resume-card__description-text:not(.resume-card__description-text--expanded) + solid-ui-button.resume-card__description-toggle {
  top: var(--resume-description-toggle-line-top);
  bottom: auto;
  transform: translateY(var(--resume-description-toggle-line-translate-y));
}

.resume-card__description-text--expanded + .resume-card__description-toggle,
.resume-card__description-text--expanded + solid-ui-button.resume-card__description-toggle {
  position: static;
  display: block;
  width: fit-content;
  margin-left: auto;
  top: auto;
  bottom: auto;
  transform: none;
}

.resume-card__description-text--expanded + solid-ui-button.resume-card__description-toggle::part(button) {
  position: static;
  display: inline-flex;
  top: auto;
  bottom: auto;
  transform: none;
}

.resume-card__skill,
.resume-card__language {
  text-align: left;
  margin: var(--resume-card-item-gap) 0;
  font-size: var(--font-size-base, 1rem);
  line-height: var(--line-height-base, 1.5);
}

.resume-card__section > h3 {
  color: var(--resume-card-heading-color);
  font-size: var(--font-size-xl, 1.375rem);
  font-weight: var(--font-weight-md, 500);
  line-height: var(--line-height-tight, 1.4);
  margin-bottom: var(--resume-card-item-gap);
  border-bottom: 1px solid var(--resume-card-heading-border);
  padding-bottom: var(--resume-card-item-gap);
}

/* Compact layout */
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .resume-card__item {
  --resume-card-title-size: var(--font-size-lg, 1.125rem);
  --resume-card-organization-size: var(--font-size-md, 1rem);
  --resume-card-location-size: var(--font-size-sm, 0.875rem);
  --resume-card-period-size: var(--font-size-xxs, 0.75rem);
  --resume-card-description-size: var(--font-size-sm, 0.875rem);
  --resume-card-description-offset: 0rem;
  grid-template-columns: minmax(0, 1fr);
  grid-template-areas:
    "title"
    "organization"
    "period"
    "description";
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .resume-card__item-header {
  align-items: flex-start;
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .resume-card__item-period {
  justify-self: start;
  text-align: left;
}

@media (max-width: 576px) {
  .resume-card__item {
    --resume-card-title-size: var(--font-size-lg, 1.125rem);
    --resume-card-organization-size: var(--font-size-md, 1rem);
    --resume-card-location-size: var(--font-size-sm, 0.875rem);
    --resume-card-period-size: var(--font-size-xxs, 0.75rem);
    --resume-card-description-size: var(--font-size-sm, 0.875rem);
    --resume-card-description-offset: 0rem;
    grid-template-columns: minmax(0, 1fr);
    grid-template-areas:
      "title"
      "organization"
      "period"
      "description";
  }

  .resume-card__item-header {
    align-items: flex-start;
  }

  .resume-card__item-period {
    justify-self: start;
    text-align: left;
  }
}

@container profile-pane (max-width: 576px) {
  .resume-card__item {
    --resume-card-title-size: var(--font-size-lg, 1.125rem);
    --resume-card-organization-size: var(--font-size-md, 1rem);
    --resume-card-location-size: var(--font-size-sm, 0.875rem);
    --resume-card-period-size: var(--font-size-xxs, 0.75rem);
    --resume-card-description-size: var(--font-size-sm, 0.875rem);
    --resume-card-description-offset: 0rem;
    grid-template-columns: minmax(0, 1fr);
    grid-template-areas:
      "title"
      "organization"
      "period"
      "description";
  }

  .resume-card__item-header {
    align-items: flex-start;
  }

  .resume-card__item-period {
    justify-self: start;
    text-align: left;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/sections/resume/ResumeSection.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,kDAAkD;EAClD,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,kDAAkD;EAClD,oDAAoD;EACpD,qDAAqD;EACrD,gCAAgC;EAChC,wBAAwB;EACxB,4BAA4B;EAC5B,4CAA4C;EAC5C,sCAAsC;EACtC,kCAAkC;EAClC,kDAAkD;AACpD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,qDAAqD;EACrD,kDAAkD;EAClD,oDAAoD;EACpD,oDAAoD;EACpD,mDAAmD;EACnD,iFAAiF;EACjF,uDAAuD;EACvD,wDAAwD;EACxD,uFAAuF;EACvF,0DAA0D;EAC1D,6DAA6D;EAC7D,mFAAmF;EACnF,0DAA0D;EAC1D,6DAA6D;EAC7D,iFAAiF;EACjF,wDAAwD;EACxD,2DAA2D;EAC3D,oFAAoF;EACpF,6DAA6D;EAC7D,gEAAgE;EAChE,kEAAkE;EAClE,4DAA4D;AAC9D;;AAEA,mBAAmB;AACnB;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C;;;6BAG2B;EAC3B,yCAAyC;EACzC,mCAAmC;EACnC,kBAAkB;EAClB,yCAAyC;EACzC,sCAAsC;EACtC,yCAAyC;EACzC,MAAM;AACR;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,kCAAkC;EAClC,YAAY;AACd;;AAEA;;;EAGE,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,qCAAqC;EACrC,wCAAwC;EACxC,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;EACT,sCAAsC;EACtC,yCAAyC;EACzC,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;EAC5C,+CAA+C;EAC/C,mDAAmD;AACrD;;AAEA;;EAEE,wCAAwC;EACxC,2CAA2C;EAC3C,+CAA+C;AACjD;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,6DAA6D;EAC7D,4CAA4C;EAC5C,wEAAwE;EACxE,iDAAiD;EACjD,wDAAwD;EACxD,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,2CAA2C;EAC3C,8CAA8C;EAC9C,kDAAkD;EAClD,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,qDAAqD;EACrD,SAAS;EACT,4CAA4C;EAC5C,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,oCAAoC;EACpC,kDAAkD;EAClD,aAAa;EACb,wCAAwC;EACxC,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,oDAAoD;EACpD,kDAAkD;EAClD,gCAAgC;EAChC,wBAAwB;EACxB,4BAA4B;EAC5B,4CAA4C;EAC5C,sCAAsC;EACtC,kCAAkC;EAClC,kDAAkD;AACpD;;AAEA;;EAEE,8CAA8C;EAC9C,YAAY;EACZ,wEAAwE;AAC1E;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,qCAAqC;EACrC,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;EACxC,uCAAuC;EACvC,0CAA0C;EAC1C,0CAA0C;EAC1C,0DAA0D;EAC1D,2CAA2C;AAC7C;;AAEA,mBAAmB;AACnB;EACE,uDAAuD;EACvD,0DAA0D;EAC1D,0DAA0D;EAC1D,wDAAwD;EACxD,6DAA6D;EAC7D,sCAAsC;EACtC,qCAAqC;EACrC;;;;iBAIe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,uDAAuD;IACvD,0DAA0D;IAC1D,0DAA0D;IAC1D,wDAAwD;IACxD,6DAA6D;IAC7D,sCAAsC;IACtC,qCAAqC;IACrC;;;;mBAIe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,uDAAuD;IACvD,0DAA0D;IAC1D,0DAA0D;IAC1D,wDAAwD;IACxD,6DAA6D;IAC7D,sCAAsC;IACtC,qCAAqC;IACrC;;;;mBAIe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;AACF","sourcesContent":["/* Resume section styles. */\n\n/* Section actions */\n.resume__edit-button {\n  width: auto;\n  min-width: 0;\n  max-width: none;\n  padding: var(--spacing-xxs, 0.3125rem);\n  border: none;\n  background: none;\n  color: var(--color-primary, #7C4DFF);\n  cursor: var(--profile-interactive-cursor, pointer);\n  font-size: var(--font-size-sm, 0.875rem);\n}\n\nsolid-ui-button.resume__edit-button {\n  width: auto;\n  min-width: 0;\n  max-width: none;\n  --button-height-sm: 0;\n  --button-padding-sm: var(--spacing-xxs, 0.3125rem);\n  --button-font-size-sm: var(--font-size-sm, 0.875rem);\n  --button-font-weight: var(--font-weight-regular, 400);\n  --button-background: transparent;\n  --button-border-width: 0;\n  --button-border: transparent;\n  --button-text: var(--color-primary, #7C4DFF);\n  --button-hover-background: transparent;\n  --button-hover-border: transparent;\n  --button-hover-text: var(--color-primary, #7C4DFF);\n}\n\n.resume__edit-button:hover {\n  text-decoration: underline;\n}\n\nsolid-ui-button.resume__edit-button:hover::part(button),\nsolid-ui-button.resume__edit-button:focus-visible::part(button) {\n  text-decoration: underline;\n}\n\n.resume-card {\n  --resume-card-section-gap: var(--spacing-md, 1.25rem);\n  --resume-card-item-gap: var(--spacing-xs, 0.75rem);\n  --resume-card-header-gap: var(--spacing-sm, 0.75rem);\n  --resume-card-column-gap: var(--spacing-md, 1.25rem);\n  --resume-card-row-gap: var(--spacing-2xs, 0.625rem);\n  --resume-card-title-color: var(--color-text-subheading, var(--gray-900, #101828));\n  --resume-card-title-size: var(--font-size-lg, 1.125rem);\n  --resume-card-title-weight: var(--font-weight-bold, 600);\n  --resume-card-organization-color: var(--color-text-secondary, var(--gray-600, #4A5565));\n  --resume-card-organization-size: var(--font-size-md, 1rem);\n  --resume-card-organization-weight: var(--font-weight-md, 500);\n  --resume-card-location-color: var(--color-text-secondary, var(--gray-600, #4A5565));\n  --resume-card-location-size: var(--font-size-sm, 0.875rem);\n  --resume-card-location-weight: var(--font-weight-normal, 400);\n  --resume-card-period-color: var(--color-text-secondary, var(--gray-600, #4A5565));\n  --resume-card-period-size: var(--font-size-sm, 0.875rem);\n  --resume-card-period-weight: var(--font-weight-normal, 400);\n  --resume-card-description-color: var(--color-text-primary, var(--gray-700, #364153));\n  --resume-card-description-size: var(--font-size-sm, 0.875rem);\n  --resume-card-description-weight: var(--font-weight-normal, 400);\n  --resume-card-heading-color: var(--color-text-subheading, #101828);\n  --resume-card-heading-border: var(--color-border-pale, #eee);\n}\n\n/* Section layout */\n.resume-card__section {\n  margin-bottom: var(--resume-card-section-gap);\n}\n\n.resume-card__section > ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.resume-card__item {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  grid-template-areas:\n    \"title period\"\n    \"organization organization\"\n    \"description description\";\n  column-gap: var(--resume-card-column-gap);\n  row-gap: var(--resume-card-row-gap);\n  align-items: start;\n  margin: 0 0 var(--resume-card-item-gap) 0;\n  font-size: var(--font-size-base, 1rem);\n  line-height: var(--line-height-base, 1.5);\n  gap: 0;\n}\n\n.resume-card__item:last-child {\n  margin-bottom: 0;\n}\n\n.resume-card__item-header {\n  grid-area: title;\n  display: flex;\n  align-items: baseline;\n  gap: var(--resume-card-header-gap);\n  min-width: 0;\n}\n\n.resume-card__item-header h3,\n.resume-card__item-header h4,\n.resume-card__item-header time {\n  margin: 0;\n}\n\n.resume-card__item-header h3,\n.resume-card__item-header h4 {\n  min-width: 0;\n  color: var(--resume-card-title-color);\n  font-size: var(--resume-card-title-size);\n  font-weight: var(--resume-card-title-weight);\n  line-height: var(--line-height-tight, 1.4);\n}\n\n.resume-card__item-period {\n  grid-area: period;\n  justify-self: end;\n  text-align: right;\n  margin: 0;\n  color: var(--resume-card-period-color);\n  font-size: var(--resume-card-period-size);\n  font-weight: var(--resume-card-period-weight);\n  line-height: var(--line-height-tight, 1.4);\n}\n\n.resume-card__organization {\n  grid-area: organization;\n  margin: 0;\n  line-height: var(--line-height-base, 1.5);\n}\n\n.resume-card__organization-name {\n  color: var(--resume-card-organization-color);\n  font-size: var(--resume-card-organization-size);\n  font-weight: var(--resume-card-organization-weight);\n}\n\n.resume-card__organization-separator,\n.resume-card__organization-location {\n  color: var(--resume-card-location-color);\n  font-size: var(--resume-card-location-size);\n  font-weight: var(--resume-card-location-weight);\n}\n\n/* Description toggle */\n.resume-card__description-wrap {\n  grid-area: description;\n  --resume-card-description-offset: var(--spacing-sm, 0.938rem);\n  --resume-description-toggle-inline-offset: 0;\n  --resume-description-toggle-line-top: calc(100% - 1.5em + 0.28em - 11px);\n  --resume-description-toggle-line-translate-y: 7px;\n  --resume-description-overflow-padding-inline-end: 4.5rem;\n  margin: var(--resume-card-description-offset) 0 0;\n  position: relative;\n  isolation: isolate;\n}\n\n.resume-card__description-text {\n  margin: 0;\n  width: 100%;\n  max-width: none;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  color: var(--resume-card-description-color);\n  font-size: var(--resume-card-description-size);\n  font-weight: var(--resume-card-description-weight);\n  line-height: var(--line-height-base, 1.5);\n  overflow: hidden;\n}\n\n.resume-card__description-text--overflowing {\n  padding-right: var(--resume-description-overflow-padding-inline-end);\n}\n\n.resume-card__description-text--expanded {\n  display: block;\n  -webkit-line-clamp: unset;\n  line-clamp: unset;\n  padding-right: 0;\n  overflow: visible;\n}\n\n.resume-card__description-toggle,\nsolid-ui-button.resume-card__description-toggle {\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  right: var(--resume-description-toggle-inline-offset);\n  bottom: 0;\n  background-color: var(--color-card-bg, #FFF);\n  white-space: nowrap;\n  z-index: 0;\n}\n\n.resume-card__description-toggle {\n  border: 0;\n  background: transparent;\n  color: var(--color-primary, #7C4DFF);\n  cursor: var(--profile-interactive-cursor, pointer);\n  font: inherit;\n  font-size: var(--font-size-sm, 0.875rem);\n  line-height: var(--line-height-base, 1.5);\n  min-height: auto;\n  min-width: auto;\n}\n\nsolid-ui-button.resume-card__description-toggle {\n  min-height: 0;\n  min-width: 0;\n  --button-height-sm: 0;\n  --button-padding-sm: 0;\n  --button-font-size-sm: var(--font-size-sm, 0.875rem);\n  --button-line-height: var(--line-height-base, 1.5);\n  --button-background: transparent;\n  --button-border-width: 0;\n  --button-border: transparent;\n  --button-text: var(--color-primary, #7C4DFF);\n  --button-hover-background: transparent;\n  --button-hover-border: transparent;\n  --button-hover-text: var(--color-primary, #7C4DFF);\n}\n\n.resume-card__description-wrap .resume-card__description-text:not(.resume-card__description-text--expanded) + .resume-card__description-toggle,\n.resume-card__description-wrap .resume-card__description-text:not(.resume-card__description-text--expanded) + solid-ui-button.resume-card__description-toggle {\n  top: var(--resume-description-toggle-line-top);\n  bottom: auto;\n  transform: translateY(var(--resume-description-toggle-line-translate-y));\n}\n\n.resume-card__description-text--expanded + .resume-card__description-toggle,\n.resume-card__description-text--expanded + solid-ui-button.resume-card__description-toggle {\n  position: static;\n  display: block;\n  width: fit-content;\n  margin-left: auto;\n  top: auto;\n  bottom: auto;\n  transform: none;\n}\n\n.resume-card__description-text--expanded + solid-ui-button.resume-card__description-toggle::part(button) {\n  position: static;\n  display: inline-flex;\n  top: auto;\n  bottom: auto;\n  transform: none;\n}\n\n.resume-card__skill,\n.resume-card__language {\n  text-align: left;\n  margin: var(--resume-card-item-gap) 0;\n  font-size: var(--font-size-base, 1rem);\n  line-height: var(--line-height-base, 1.5);\n}\n\n.resume-card__section > h3 {\n  color: var(--resume-card-heading-color);\n  font-size: var(--font-size-xl, 1.375rem);\n  font-weight: var(--font-weight-md, 500);\n  line-height: var(--line-height-tight, 1.4);\n  margin-bottom: var(--resume-card-item-gap);\n  border-bottom: 1px solid var(--resume-card-heading-border);\n  padding-bottom: var(--resume-card-item-gap);\n}\n\n/* Compact layout */\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .resume-card__item {\n  --resume-card-title-size: var(--font-size-lg, 1.125rem);\n  --resume-card-organization-size: var(--font-size-md, 1rem);\n  --resume-card-location-size: var(--font-size-sm, 0.875rem);\n  --resume-card-period-size: var(--font-size-xxs, 0.75rem);\n  --resume-card-description-size: var(--font-size-sm, 0.875rem);\n  --resume-card-description-offset: 0rem;\n  grid-template-columns: minmax(0, 1fr);\n  grid-template-areas:\n    \"title\"\n    \"organization\"\n    \"period\"\n    \"description\";\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .resume-card__item-header {\n  align-items: flex-start;\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .resume-card__item-period {\n  justify-self: start;\n  text-align: left;\n}\n\n@media (max-width: 576px) {\n  .resume-card__item {\n    --resume-card-title-size: var(--font-size-lg, 1.125rem);\n    --resume-card-organization-size: var(--font-size-md, 1rem);\n    --resume-card-location-size: var(--font-size-sm, 0.875rem);\n    --resume-card-period-size: var(--font-size-xxs, 0.75rem);\n    --resume-card-description-size: var(--font-size-sm, 0.875rem);\n    --resume-card-description-offset: 0rem;\n    grid-template-columns: minmax(0, 1fr);\n    grid-template-areas:\n      \"title\"\n      \"organization\"\n      \"period\"\n      \"description\";\n  }\n\n  .resume-card__item-header {\n    align-items: flex-start;\n  }\n\n  .resume-card__item-period {\n    justify-self: start;\n    text-align: left;\n  }\n}\n\n@container profile-pane (max-width: 576px) {\n  .resume-card__item {\n    --resume-card-title-size: var(--font-size-lg, 1.125rem);\n    --resume-card-organization-size: var(--font-size-md, 1rem);\n    --resume-card-location-size: var(--font-size-sm, 0.875rem);\n    --resume-card-period-size: var(--font-size-xxs, 0.75rem);\n    --resume-card-description-size: var(--font-size-sm, 0.875rem);\n    --resume-card-description-offset: 0rem;\n    grid-template-columns: minmax(0, 1fr);\n    grid-template-areas:\n      \"title\"\n      \"organization\"\n      \"period\"\n      \"description\";\n  }\n\n  .resume-card__item-header {\n    align-items: flex-start;\n  }\n\n  .resume-card__item-period {\n    justify-self: start;\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
